import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TripWarningComponent } from './trip-warning/trip-warning.component';
import { MatTableDataSource } from '@angular/material/table';
import { AuditLogComponent } from 'src/app/shared/audit-log/audit-log/audit-log.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-adjustment-trips',
  templateUrl: './adjustment-trips.component.html',
  styleUrls: ['./adjustment-trips.component.scss']
})
export class AdjustmentTripsComponent {

  public _mFormGroup: FormGroup;
  public mLocation = new FormControl("", Validators.required);
  public mSite = new FormControl("", Validators.required);
  public mFromDate = new FormControl('');
  public mToDate = new FormControl("", Validators.required);
  public mstatus = new FormControl("", Validators.required);

  mData: any[] = [];
  _mCurrentUserData: any;
  _mCurrentUserRoleFlag: boolean = false;
  page: number = 1;
  size: number = 20;
  _mCurrentNumber: number = 0;
  _mTotalElements: number = 0;
  _mNumberOfElements: number = 0;
  _mTotalPage: number = 1;
  itemsPerPage = 0;
  dataSource = new MatTableDataSource<any>(this.mData);
  displayedColumns = ['date', 'tripCode', 'siteName', 'vendorName', 'employeeId', 'logType', 'nearestShiftTime', 'approximateKm', 'vehicleType', 'driverName', 'raisedOn', 'actionOn', 'actionBy', 'status', 'audit'];
  activeTabId = 1;
  statusData = [{ status: 'ALL' }, { status: 'SENT_FOR_ADMIN_APPROVAL' }, { status: 'Approved' }, { status: 'Rejected' }]
  cities: any = [];
  _mSitesData: any = [];
  minDate: any;
  maxDate: any;
  tableFlag: boolean;

  constructor(
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    public readonly serviceLocalStorage: ServiceLocalStorage,
    private ngxLoader: NgxUiLoaderService,
    public dialog: MatDialog,
    private fb: FormBuilder
  ) {
    this._mFormGroup = this.fb.group({
      location: this.mLocation,
      site: this.mSite,
      fromDate: this.mFromDate,
      toDate: this.mToDate,
      status: this.mstatus
    });
  }

  ngOnInit() {
    this._mCurrentUserData = this.serviceLocalStorage.getUserObject();
    if (!this._mCurrentUserData) return;
    const roleId = this._mCurrentUserData.userInfoDetails.role.id;
    this._mCurrentUserRoleFlag = roleId === 3 || roleId === 4;
    this.loadCities();
  }

  loadCities() {
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getserchlocationlist,
      success => {
        if (success.status == 200) {
          this.cities = success.body;

          const userLocationId =
            this._mCurrentUserData?.userInfoDetails?.site?.location?.locationId;

          const selectedLocationId =
            userLocationId && this.cities?.some(c => c.locationId === userLocationId || c.id === userLocationId)
              ? userLocationId
              : this.cities?.[0]?.locationId || this.cities?.[0]?.id || '';

          if (selectedLocationId) {
            this.mLocation.setValue(selectedLocationId);
            this.getSitesByCityId();
          }

        } else {
          this.cities = [];
        }
      },
      error => {
        this.notifyService.showError(error, null);
      }
    );
  }

  getSitesByCityId() {
    this.mSite.setValue('');

    this.apiService.doGetRequestWithResponse(
      ApiConstants.getserchsitelist + this.mLocation.value,
      success => {
        if (success.status == 200) {
          this._mSitesData = success.body;

          const userSiteId =
            this._mCurrentUserData?.userInfoDetails?.site?.siteId;

          const selectedSiteId =
            userSiteId && this._mSitesData?.some(s => s.siteId === userSiteId)
              ? userSiteId
              : this._mSitesData?.[0]?.siteId;

          if (selectedSiteId) {
            this.mSite.setValue(selectedSiteId);
          }

          if (!this.mstatus.value) {
            this.mstatus.setValue(
              this.statusData?.length ? this.statusData[0].status : 'ALL'
            );
          }
          if (!this.mFromDate.value) {
            this.mFromDate.setValue(new Date() as any);
          }
          if (!this.mToDate.value) {
            this.mToDate.setValue(new Date() as any);
          }

        } else {
          this._mSitesData = [];
          this.notifyService.showInfo('No Sites Found!', null);
        }
      },
      error => {
      }
    );
  }

  dateChanged(data) {
    this.mToDate.setValue("");
    this.minDate = data.value;
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return d.getFullYear() + "-" + mm + "-" + dt;
  }

  pendingStatusRequest(showmsg: string, i: number) {
    const statusMessages: { [key: string]: string } = {
      REJECTED_BY_ADMIN: "Are you sure want to Reject ?",
      CANCELLED_BY_ADMIN: "Are you sure want to Cancel ?",
      SENT_FOR_VENDOR_APPROVAL: "Are you sure want to Approve ?"
    };

    const message = statusMessages[showmsg];
    if (!message) return;
    const dialogRef = this.dialog.open(TripWarningComponent, {
      data: message,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onSubmitStatus(showmsg, i);
      }
    });
  }

  onSubmitStatus(showmsg: string, index: number) {
    const data = { ...this.mData[index] };
    data.status = (showmsg === 'SENT_FOR_VENDOR_APPROVAL') ? 'Approved' : showmsg;
    this.ngxLoader.start();
    const url = `${ApiConstants.updateAdjustmentTrip}${data.id}&status=${data.status}`;

    this.apiService.doPutRequestWithResponse(url, '',
      (success) => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.notifyService.showSuccess(success.body.message, null);
          this.onSubmit();
        } else {
          this.notifyService.showWarning("Error while Booking update", null);
        }
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError("An error occurred during the update.", null);
      }
    );
  }

  onAuditLogClicked(e) {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.getAdjustmentTripAudit + e.id, (success) => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        let data = success.body;
        let object = Object.entries(e);
        data.data.push(object[2]);
        this.dialog.open(AuditLogComponent, {
          autoFocus: false,
          maxHeight: '80vh',
          data: data,
          disableClose: true
        });
      } else {
        this.notifyService.showInfo("No audit logs found", null);
      }
    }, (error) => {
      this.ngxLoader.stop();
      console.error("Error fetching audit logs:", error);
    });
  }

  onSubmit() {
    if (!this._mFormGroup.valid) return;
    this.ngxLoader.start();
    const site = this.mSite.value;
    const fromDate = this.formatDate(this.mFromDate.value);
    const toDate = this.formatDate(this.mToDate.value);
    const status = this.mstatus.value;
    const page = this.page - 1;

    const requestUrl = `${ApiConstants.getAdjustmentTrip}${site}&fromDate=${fromDate}&toDate=${toDate}&status=${status}&page=${page}&size=${this.size}`;
    this.apiService.doGetRequestWithResponse(requestUrl,
      (success) => {
        this.ngxLoader.stop();
        if (success.status !== 200) {
          this.resetTableData();
          return;
        }
        const data = success.body?.data || [];
        this.tableFlag = true;
        if (data.length === 0) {
          this.resetTableData();
          return;
        }

        const locarr = data.map(element => ({
          id: element.id,
          date: element.date,
          tripCode: element.tripCode,
          siteName: element.siteName,
          vendorName: element.vendorName,
          employeeId: element.employeeId,
          logType: element.logType,
          nearestShiftTime: element.nearestShiftTime,
          approximateKm: element.approximateKm,
          status: element.status,
          vehicleType: element.vehicleType,
          driverName: element.driverName,
          raisedOn: element.raisedOn,
          actionOn: element.actionOn,
          actionBy: element.actionBy
        }));

        this.mData = locarr;
        this.dataSource.data = locarr;
        const { pageNo, totalPages, size, totalElements, noOfElements } = success.body;
        this._mCurrentNumber = pageNo;
        this._mTotalPage = totalPages;
        this.size = size;
        this._mTotalElements = totalElements;
        this._mNumberOfElements = noOfElements;
      },
      (error) => {
        this.ngxLoader.stop();
        this.notifyService.showError("error", null);
        this.resetTableData();
      }
    );
  }

  resetTableData() {
    this.mData = [];
    this._mCurrentNumber = 0;
    this._mTotalElements = 0;
    this._mTotalPage = 0;
    this._mNumberOfElements = 0;
    this.size = 0;
  }

  onNewPageRequest($event) {
    if ($event !== null || $event !== undefined) {
      this.page = $event;
      this.onSubmit();
    }
  }

}




